import {Poi} from '../../react-app-env';
import React from 'react';
import ListViewGroup from '../listview/listviewgroup/ListViewGroup';
import {i18n} from '../../i18n/i18n';
import ListViewItem from '../listview/listviewitem/ListViewItem';
import {noop} from '../../utils/Utils';
import {PoiMetaData} from '../../services/MetaDataService';
import {DefaultItemDecorations} from '../listview/listviewitem/ListViewItem.types';
import {useReadonly} from '../context/ReadonlyContext';

export interface DescriptionGroupProps {
  poi: Poi;
  metaData: PoiMetaData | null;
}

const DescriptionGroup: React.FunctionComponent<DescriptionGroupProps> = ({ poi, metaData }) => {
  const readonly = useReadonly();

  const listItems = [];

  if (metaData?.description) {
    listItems.push(<ListViewItem title={metaData?.description}/>);
  }
  if (poi.description) {
    listItems.push(<ListViewItem title={poi.description}/>);
  }

  if (!readonly) {
    const editDescriptionLabel = poi.description
        ? i18n().poiDetails.description.editDescription
        : i18n().poiDetails.description.addDescription;
    listItems.push(
        <ListViewItem title={editDescriptionLabel}
                      iconCategory="fa-comment fa-regular"
                      decoration={DefaultItemDecorations.EDIT}
                      onClick={() => noop()}/>
    );
  }

  return listItems.length === 0 ? null : (
      <ListViewGroup>
        {listItems}
      </ListViewGroup>
  );
};

export default DescriptionGroup;
